export function getCookiesAccept (): string {
  return !!localStorage.getItem('ej_user_is_cookies_accept');
}

export function setCookiesAccept () {
  localStorage.setItem('ej_user_is_cookies_accept', JSON.stringify(true));
}
